/**
 * `#faq` — bản tiếng Anh, lấy từ thuộc tính `data-en` trong `template.html` (1027–1039).
 * Hình dạng phải khớp `vi/faq.ts`; lệch một khoá là lỗi biên dịch.
 */
interface FaqEntry {
  readonly question: string;
  readonly answer: string;
}

export const faq = {
  heading: 'Frequently asked questions',
  items: [
    {
      question: 'Can Nexa be deployed on-premise?',
      answer:
        'Yes. Nexa runs as managed cloud, private cloud or fully on-premise with the same feature set; NewEra Inc. supports the installation and operator handover.',
    },
    {
      question: 'Do we have to migrate everything at once?',
      answer:
        'No. Most teams start with chat on a few channels, then turn on Project Manager and the Knowledge Base as they go.',
    },
    {
      question: 'What data can the AI agents read?',
      answer:
        'Only what its scope allows: a Public Agent reads its shared sources, a Department Agent is limited to its whitelist, and an Alias Agent inherits exactly the access rights of the employee who owns it.',
    },
    {
      question: 'Is there a mobile app?',
      answer:
        'Yes — a mobile app with bottom-tab navigation covers chat, topics, approvals and tasks; the full workspace lives on web.',
    },
    {
      question: 'Which languages does the interface support?',
      answer: 'Vietnamese and English, switchable per user.',
    },
    {
      question: 'When will pricing be published?',
      answer:
        'Plans are being finalised. Contact us and we will quote a pilot for your team in the meantime.',
    },
  ] as readonly FaqEntry[],
};
